import { useCallback } from 'react';
import { Dispatch } from 'redux';
import * as actions from './webUiConfigActions';

export const useSetWebUiConfigByClientId = (dispatch: Dispatch<any>) => {
    return useCallback(
        (clientId: string | null) => {
            dispatch(actions.setWebUiConfigByClientId(clientId));
        },
        [dispatch],
    );
};

export default useSetWebUiConfigByClientId;
